import React from 'react';

/**
 * Badge accanto al nome cliente:
 *   - "Anonimizzato" (grigio) se i dati personali sono già stati anonimizzati;
 *   - "Cliente eliminato" (giallo) se eliminato ma non ancora anonimizzato;
 *   - nulla se il cliente è attivo.
 * `anonymized` ha precedenza su `deleted`.
 */
interface Props {
    deleted?: boolean | null;
    anonymized?: boolean | null;
    className?: string;
}

export const ClientBadge: React.FC<Props> = ({ deleted, anonymized, className = 'ml-2' }) => {
    if (anonymized) {
        return (
            <span
                className={`${className} inline-block text-[10px] font-medium bg-slate-100 text-slate-600 border border-slate-200 px-1.5 py-0.5 rounded`}
                title="Cliente anonimizzato ai sensi del GDPR (post-6 mesi da eliminazione)"
            >
                Anonimizzato
            </span>
        );
    }
    if (deleted) {
        return (
            <span
                className={`${className} inline-block text-[10px] font-medium bg-amber-50 text-amber-700 border border-amber-200 px-1.5 py-0.5 rounded`}
                title="Cliente eliminato: la riapertura del mandato è bloccata"
            >
                Cliente eliminato
            </span>
        );
    }
    return null;
};

export default ClientBadge;
